<template lang="html">
  <div class="row-block cv-link" v-if="response.resume_url">
    <div>{{ $tr('responses.resume.cvLink') }}</div>
    <div>
      <div class="cv-row">
        <a class="cv-row-resume-link" v-if="response.resume_url" :href="response.resume_url" target="_blank" rel="noopener" v-tooltip="{
          content: response.resume_url,
          placement: 'top-center',
          classes: 'cv-tooltip'
        }">
          <svg class="cv-row-icon">
            <use xlink:href="/static/icons/cv-icons.svg#file"></use>
          </svg>
        </a>
        <a class="cv-row-resume-link" v-if="response.second_resume_url" :href="response.second_resume_url" target="_blank" rel="noopener" v-tooltip="{
          content: response.second_resume_url,
          placement: 'top-center',
          classes: 'cv-tooltip'
        }">
          <svg class="cv-row-icon">
            <use xlink:href="/static/icons/cv-icons.svg#url"></use>
          </svg>
        </a>
      </div>
    </div>
  </div>
</template>

<script>
import CVLink from '@/components/shared/CVLink.vue'
export default {
  name: 'process-response-resume-additional-info',

  components: {
    CVLink
  },

  props: {
    response: Object,
    default: null
  }
}
</script>

<style lang="scss" scoped>
    .row-block {
        margin-bottom: 20px;
        display: flex;

        & > div {
            width: 66%;
        }
        & > div:first-child {
            font-weight: bold;
            width: 33%;
        }
    }
</style>
